<template>
  <el-main class="container">
    <Nav>
      <div slot="left" class="left">
        <el-input
          v-model.trim="body.word"
          clearable
          class="input-text"
          maxlength="30"
          placeholder="请输入昵称进行搜索"/>
          <el-button
            @click="event().search()"
            type="primary">搜索</el-button>
          <!-- <div class="status">
            <span>认证状态</span>
            <select class="select" @change="event().selectFn($event)">
              <option value="all">全部</option>
              <option value="pass">已认证</option>
              <option value="noPass">未认证</option>
            </select>
          </div> -->

          <div class="industry-box">
            <span>产业筛选</span>
            <el-select v-model="selectIndustry" @change="handleIndustry" clearable placeholder="请选择产业">
              <el-option
                v-for="item in industryList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
      </div>
      <div
        class="right"
        slot="right">
        <el-button
          v-show="hasAuthority('userExcel')"
          type="primary"
          class="excel"
          @click="network().getExcel()">
          导出Excel</el-button>
      </div>
    </Nav>

    <Table
      v-loading="loading"
      border
      align="center"
      :header-row-style="{height: '100px'}"
      :header-cell-style="{background:'#f4f4f4',color:'#606266'}"
      :row-style="{height: '150px'}"
      :column="datasource.column"
      :data="datasource.data"
      pagination
      background
      :paginationTop="'30px'"
      :paginationAlign="'center'"
      layout="prev, pager, next, sizes, jumper"
      :page-sizes="[5, 10, 20, 30]"
      :pager-count="5"
      :current-page.sync="body.pageIndex"
      :total="datasource.total"
      :page-size="body.pageSize"
      @size-change="handleSizeChange"
      @p-current-change="handleCurrentChange"
    >
    </Table>

    <el-dialog
      title="认证信息"
      width="30%"
      :visible.sync="dialogVisible">
      <div class="dialog-list">
        <template v-for="item in dialogInfoList">
          <div class="item" :key="item.uuid">
            <div class="row">
              <div class="half">
                <div class="name">认证状态:</div>
                <div class="val">{{item.isAuthentication | isAuthentication}}</div>
              </div>
              <div class="half">
                <div class="name">所属产业:</div>
                <div class="val">{{item.industryName}}</div>
              </div>
            </div>
            <div class="row">
              <div class="half">
                <div class="name">姓名:</div>
                <div class="val">{{item.name}}</div>
              </div>
              <div class="half">
                <div class="name">手机号:</div>
                <div class="val">{{item.mobile}}</div>
              </div>
            </div>
            <div class="row">
              <div class="half">
                <div class="name">企业名称:</div>
                <div class="val">{{item.enterpriseName}}</div>
              </div>
              <div class="half">
                <div class="name">企业房号:</div>
                <div class="val">{{item.enterpriseRoom}}</div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import { getIndustrySelectList } from '@/api/industry'
import Nav from '@/components/nav'
import utils from '@/jslib/utils'
import {
  getUserList, getExcel, disableUser
} from '@/api/user'
export default {
  name: 'UserList',
  data() {
    return {
      loading: false,
      dialogVisible: false,
      dialogInfoList: [],
      industryList: [],
      selectIndustry: '',
      body: {
        word: '',
        pageIndex: 1,
        pageSize: 10,
        industryUuid: ''
      },
      excelBody: {
        isAuthentication: '',
        word: '',
        industryUuid: ''
      },
      datasource: {
        total: 0,
        data: [],
        column: [
          {
            label: 'id',
            width: '100',
            render:(h,scoped) => {
              let text = this.body.pageSize * (this.body.pageIndex - 1) + scoped.$index + 1
              return(
                <div>{text}</div>
              )
            }
          },
          {
            prop: 'wxAvatar',
            label: '头像',
            render: (h, scoped) => {
              return(
                <div><img src={scoped.row.wxAvatar}></img></div>
              )
            }
          },
          {
            prop: 'wxName',
            label: '昵称'
          },
          {
            prop: 'mobile',
            label: '手机号'
          },
          {
            label: '认证状态',
            render: (h, scoped) =>{
              let text = ''
              if(scoped.row.enterpriseList.length > 0){
                text = `已认证（${scoped.row.enterpriseList.length}）`
                return(
                  <div>
                    <el-link underline={false} type='primary' onClick={() => { this.ShowCertified(scoped.row) }}>{text}</el-link>
                  </div>
                )
              } else {
                text = '-'
                return(
                  <div>{text}</div>
                )
              }
            }
          },
          {
            label: '认证产业',
            render: (h, scoped) =>{
              let text = ''
              if(scoped.row.industryNameList.length > 0){
                let list = []
                scoped.row.industryNameList.forEach(item=>{
                  list.push(item)
                })
                text = list.join('、')
                return(
                  <div>
                    <el-link underline={false} type='primary'>{text}</el-link>
                  </div>
                )
              } else {
                text = '-'
                return(
                  <div>{text}</div>
                )
              }
            }
          },
          {
            prop: 'createTime',
            label: '注册时间'
          },
          {
            label: '操作',
            width: '300',
            render: (h, scoped) =>{
              let text = ''
              scoped.row.status === 1 ? text = '禁用' : text = '解禁'
              console.log(this.hasAuthority('userDetail'))
              return(
                <div>
                  <el-link v-show={this.hasAuthority('userBan')} underline={false} type='primary' onClick={() => { this.handleDisable(scoped.row) }}>{text}</el-link>&nbsp;&nbsp;
                  <el-link v-show={this.hasAuthority('userDetail')} underline={false} type='primary' onClick={() => { this.userDetail(scoped.row) }}>查看详情</el-link>&nbsp;&nbsp;
                </div>
              )
            }
          }
        ]
      },
    }
  },
  filters: {
    isAuthentication(type){
      let text = ''
      type === 1 ? text = '已认证' : text = '未认证'
      return text
    }
  },
  methods: {
    event() {
      return {
        search: () => {
          this.body.pageIndex = 1
          this.network().getUserList()
        },
        selectFn: (e) => {
          if (e.target.value === 'all') {
            this.body.isAuthentication = ''
          } else if (e.target.value === 'pass') {
            this.body.isAuthentication = 1
          } else this.body.isAuthentication = 0
          this.network().getUserList()
        }
      }
    },
    network() {
      return {
        getUserList: async() => {
          this.loading = true
          const { data } = await getUserList(this.body)
          this.loading = false
          this.datasource.total = data.total
          this.datasource.data = data.list
        },
        getExcel: async() => {
          this.excelBody.word = this.body.word
          this.excelBody.industryUuid = this.body.industryUuid
          const { data } = await getExcel(this.excelBody)
          utils.exportExcel(data, '导出用户列表excel')
        },
        getIndustrySelectList: async() => {
          const { data } = await getIndustrySelectList()
          data.forEach(item => {
            this.industryList.push({
              value: item.uuid,
              label: item.name
            })
          })
        },
        disableUser: async(uuid) => {
          await disableUser(uuid)
          this.$message.success('更新成功')
          this.network().getUserList()
        }
      }
    },
    handleCurrentChange(current){
      this.body.pageIndex = current
      this.network().getUserList()
    },
    handleSizeChange(size){
      this.body.pageSize = size
      this.body.pageIndex = 1
      this.network().getUserList()
    },
    handleDisable(row){
      this.network().disableUser(row.uuid)
    },
    userDetail(row){
      this.$router.push({
        path: `/user-management/user-details/get/${row.uuid}`
      })
    },
    ShowCertified(row){
      this.dialogInfoList = row.enterpriseList
      this.dialogVisible = true
    },
    handleIndustry(id) {
      this.body.industryUuid = id
      this.body.pageIndex = 1
      this.network().getUserList()
    },
  },
  async created() {
    await this.network().getIndustrySelectList()
    await this.network().getUserList()
  },
  components: {
    Nav
  }
}
</script>

<style scoped lang="scss">
.status{
  margin-left: 60px;
  display: flex;
  align-items: center;
  .select{
    margin-left: 15px;
    width: 70px;
    padding: 2px 0;
  }
}
.right{
  height: 100%;
  display: flex;
}
Nav{
  height: 37px;
}

.dialog-list{
  .item{
    margin-bottom: 15px;
    border: 1px dashed #999;
    box-sizing: border-box;
    padding: 15px;
    border-radius: 10px;
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .row{
      display: flex;
      .half{
        flex: 1;
        display: flex;
        .name{
          width: 100px;
          color: #a1a1a1;
        }
      }
    }
  }
}

.industry-box{
  width: 300px;
  margin-left: 60px;
  display: flex;
  align-items: center;
  span{
    width: 70px;
    margin-right: 15px;
  }
}
</style>
